// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"d03c7aab","239":"79353bdd","374":"411c8f14","683":"cf4adfb9","740":"a589d34b","787":"44e022fc"}[chunkId] + ".chunk.js";
};